import { useContext } from "react";

import { I18nContext } from "./I18nProvider";

export function useIsTranslationsAvailable(): boolean {
  return useContext(I18nContext) != null;
}
